/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { Palette } from 'config';

export const MsgToUser = ({ children }) => {
  const textWithLineBreaks = children.split('\n').map((line, index) => (
    <span key={index}>
      {line}
      {index < children.split('\n').length - 1 && <br />}
    </span>
  ));
  return <ErrorMsg>{textWithLineBreaks}</ErrorMsg>;
};

export const ErrorMsg = styled.p`
  color: ${Palette.PrimaryGray._500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  white-space: nowrap;
`;

import React from 'react';
